import { useCallback } from 'react'

import { Lookup, useLookup } from '@shared/providers/src/DropdownOptionsProvider'
import { TaskKind } from '@shared/utils'

export function useTaskDoneReasons() {
  const priorAuthDoneReasons = useLookup(Lookup.PriorAuthDoneReasons)
  const gileadDoneReasons = useLookup(Lookup.GileadTaskDoneReasons)
  const appealDoneReasons = useLookup(Lookup.AppealTaskDoneReasons)
  const immediateAccessDoneReasons = useLookup(Lookup.ImmediateAccessReasons)
  const pafDoneReasons = useLookup(Lookup.PAFDoneReasons)

  return useCallback(
    (kind) => {
      if (!hasDoneReasons(kind)) return
      if (kind === TaskKind.PriorAuth) return priorAuthDoneReasons
      if (kind === TaskKind.GileadCustomerSupport) return gileadDoneReasons
      if (kind === TaskKind.Appeals) return appealDoneReasons
      if (kind === TaskKind.ImmediateAccess) return immediateAccessDoneReasons
      if (kind === TaskKind.PAF) return pafDoneReasons
    },
    [appealDoneReasons, gileadDoneReasons, immediateAccessDoneReasons, pafDoneReasons, priorAuthDoneReasons]
  )
}

export const hasDoneReasons = (kind) => {
  return [TaskKind.PriorAuth, TaskKind.GileadCustomerSupport, TaskKind.Appeals, TaskKind.ImmediateAccess, TaskKind.PAF].includes(kind)
}
